export const translations = {
  sair: {
    pt: 'Sair',
    en: 'Exit',
    de: 'Ausgang',
    es: 'Salir',
  },
};